import { Input } from './Input';
import { isEmailValid } from '@/utils/email';
import { useContext, useState } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useTranslate } from '@/hooks/useTranslate';

export const Email = () => {
  const { t } = useTranslate();
  const [emailValid, setEmailValid] = useState(true);
  const context = useContext(CheckoutContext);
  const {
    customer,
    actions: { setCustomerEmail },
  } = context;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomerEmail(e.target.value);
  };

  const handleBlur = () => {
    setEmailValid(isEmailValid(customer?.email ?? ''));
  };

  return (
    <Input
      type="text"
      placeholder={t('emailAddress')}
      value={customer?.email ?? ''}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={() => setEmailValid(true)}
      error={emailValid ? undefined : t('fieldErrors.invalidEmail')}
      className="w-full text-base md:text-sm"
    />
  );
};
